export default __webpack_public_path__ + "static/media/030_corner1_02.474009b6.mp3";